<template>
  <UICard
    title="Experimental tax-lot analytics"
    description="Use provider-reported cost basis and gains where open and closed lot coverage is complete. Disable this to return to computed analytics."
  >
    <UICheckbox
      :model-value="enabled"
      label="Use provider tax lots"
      @update:model-value="handleUpdate"
    />
  </UICard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { get } from 'lodash'

import useAnalyticsStore from '@/store/analytics'
import { useRepositoriesStore } from '@/store/repositories'

import { UICard } from '@ui/core'
import { UICheckbox } from '@ui/controllers'

const SETTING_PATH = ['analytics', 'use-provider-tax-lots']

const analyticsStore = useAnalyticsStore()
const repositoriesStore = useRepositoriesStore()

const enabled = computed(
  () => get(repositoriesStore.getCurrentUISettings, SETTING_PATH) === true,
)

const handleUpdate = (value: boolean) => {
  repositoriesStore.setCurrentUISettings([[SETTING_PATH, value]])
  analyticsStore.markAsDeprecated()
}
</script>
